import { LogLevel } from '@azure/msal-browser';

export const msalConfig = {
  auth: {
    clientId: 'e0aeba95-3e47-4ace-b449-52bec1d48d1c', //'e0aeba95-3e47-4ace-b449-52bec1d48d1c' // This is the ONLY mandatory field that you need to supply.
    authority:
      'https://login.microsoftonline.com/58be8688-6625-4e52-80d8-c17f3a9ae08a', //'https://login.microsoftonline.com/58be8688-6625-4e52-80d8-c17f3a9ae08a' // Defaults to "https://login.microsoftonline.com/common"
    redirectUri: '/', // Points to window.location.origin. You must register this URI on Azure Portal/App Registration.
    postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
    clientCapabilities: ['CP1'], // this lets the resource owner know that this client is capable of handling claims challenge.
  },
  cache: {
    cacheLocation: 'localStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            // console.info(message);
            return;
          case LogLevel.Verbose:
            // console.debug(message);
            return;
          case LogLevel.Warning:
            // console.warn(message);
            return;
        }
      },
    },
  },
};

export const loginRequest = {
  scopes: ['User.Read', 'Files.ReadWrite'],
};

export const protectedResources = {
  graphMe: {
    endpoint: 'https://graph.microsoft.com/v1.0/me',
    scopes: ['User.Read'],
  },
  graphReadDrive: {
    endpoint: 'https://graph.microsoft.com/v1.0/me/drive/root/children',
    scopes: ['Files.ReadWrite'],
  },
  graphReadKaiwaFolder: {
    endpoint:
      'https://graph.microsoft.com/v1.0/me/drive/root:/KAIWA%20Chats:/children',
    scopes: ['Files.ReadWrite'],
  },
  graphCreateChat: {
    endpoint: 'https://graph.microsoft.com/v1.0/me/drive/root/children',
    scopes: ['Files.ReadWrite'],
    data: {
      name: 'KAIWA Chats',
      folder: {},
    },
  },
  // graphCreatePrompt: {
  //     endpoint: 'https://graph.microsoft.com/v1.0/me/drive/root/children',
  //     scopes: ['Files.ReadWrite'],
  //     data: {
  //         name: 'KAIWA-Prompts',
  //         folder: {},
  //     },
  // },
  graphNewFile: {
    scopes: ['Files.ReadWrite'],
  },

  graphChatHist: {
    endpoint:
      'https://graph.microsoft.com/v1.0/me/drive/root:/KAIWA%20Chats/Chats:/children',
    scopes: ['Files.ReadWrite'],
  },
  graphPromptHist: {
    endpoint:
      'https://graph.microsoft.com/v1.0/me/drive/root:/KAIWA%20Chats/Prompts:/children',
    scopes: ['Files.ReadWrite'],
  },
  graphDeleteFile: {
    scopes: ['Files.ReadWrite'],
  },
};
